import { ScrollTrigger } from "@gsap";

function closeAllItems(items) {
	items.forEach(item => {
		const toggle = item.querySelector(".pk-accordion-item-head");
		const content = item.querySelector(".pk-accordion-item-content");

		item.classList.remove("active");
		toggle.setAttribute("aria-expanded", false);
		content.setAttribute("aria-hidden", true);
	});
}

document.addEventListener("DOMContentLoaded", function () {
	const faqContainers = document.querySelectorAll(".pk-accordion");

	faqContainers.forEach((container) => {
		const items = container.querySelectorAll(".pk-accordion-item");

		items.forEach((item) => {
			const toggle = item.querySelector(".pk-accordion-item-head");
			const content = item.querySelector(".pk-accordion-item-content");
			if (!toggle || !content) return;

			toggle.setAttribute("aria-expanded", "false");
			content.setAttribute("aria-hidden", "true");

			content.addEventListener("transitionend", (event) => {
				if (event.target !== content || event.propertyName !== "grid-template-rows") return;
				if (ScrollTrigger.getAll().length > 0) {
					ScrollTrigger.refresh();
				}
			});

			toggle.addEventListener("click", () => {
				if(!item.classList.contains('active')) {
					closeAllItems(items);
				}
				const isOpen = item.classList.toggle("active");
				toggle.setAttribute("aria-expanded", String(isOpen));
				content.setAttribute("aria-hidden", String(!isOpen));
			});
		});
	});
});
